import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CeoDashboard } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/ceo")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CeoDashboard />
    </RouteGuard>
  ),
});
